import { render, staticRenderFns } from "./SamooDemo.vue?vue&type=template&id=4f24d5e4&scoped=true"
import script from "./SamooDemo.vue?vue&type=script&lang=js"
export * from "./SamooDemo.vue?vue&type=script&lang=js"
import style0 from "./SamooDemo.vue?vue&type=style&index=0&id=4f24d5e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f24d5e4",
  null
  
)

export default component.exports